/**
 * filter keys比较
 */
import { useEffect, useRef } from 'react';
import _ from 'lodash';

type KeyItem = string | { key: string, [key: string]: any };

const getKeys = (data: Array<KeyItem>) => {
  return data.map((v) => (typeof v === 'string' ? v : v.key)).filter((v) => v);
};

const useKeysEffect = (callback: (keys: Array<string>) => void, deps: Array<KeyItem> = [], needInit = false) => {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const prevKeys = getKeys(prevDeps.current);
    const curKeys = getKeys(deps);
    const isSame = !_.difference(curKeys, prevKeys).length && !_.difference(prevKeys, curKeys);
    if ((needInit && isFirst.current) || !isSame) {
      callback(curKeys);
    }
    isFirst.current = false;
    prevDeps.current = deps;
  }, [deps]);
};

export default useKeysEffect;
